import { Types } from "../action/action";
import { callUserActions } from "../interface/callReducerTypes";
import { incomingCallUser } from "../models/callModals";

const initialState = {
  callDetails: [],
  incomingCallDetail: "",
  isIncomming: false,
  status: false,
  isCallAccepted: false,
};
export const callUserDetails = (
  state: incomingCallUser = initialState,
  action: callUserActions
) => {
  switch (action.type) {
    case Types.CONFERENCE_USER_LIST:
      return {
        ...state,
        callDetails: action.payload.callDetails,
      };

    case Types.INCOMING_CALL_POPUP:
      return {
        ...state,
        status: action.payload.status,
        incomingCallDetail: action.payload.incomingCallDetail,
      };

    default:
      return state;
  }
};
